module.exports = __webpack_public_path__ + "media/images/icons/appointments-bc56d82e6bf75adbb78def1252a3f692.svg";